var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8594 30.9375H35.0625V21.1406C35.0625 20.857 34.8305 20.625 34.5469 20.625H31.4531C31.1695 20.625 30.9375 20.857 30.9375 21.1406V30.9375H21.1406C20.857 30.9375 20.625 31.1695 20.625 31.4531V34.5469C20.625 34.8305 20.857 35.0625 21.1406 35.0625H30.9375V44.8594C30.9375 45.143 31.1695 45.375 31.4531 45.375H34.5469C34.8305 45.375 35.0625 45.143 35.0625 44.8594V35.0625H44.8594C45.143 35.0625 45.375 34.8305 45.375 34.5469V31.4531C45.375 31.1695 45.143 30.9375 44.8594 30.9375Z",
    fill: "#dbdbdb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4.125C17.0543 4.125 4.125 17.0543 4.125 33C4.125 48.9457 17.0543 61.875 33 61.875C48.9457 61.875 61.875 48.9457 61.875 33C61.875 17.0543 48.9457 4.125 33 4.125ZM33 56.9766C19.7613 56.9766 9.02344 46.2387 9.02344 33C9.02344 19.7613 19.7613 9.02344 33 9.02344C46.2387 9.02344 56.9766 19.7613 56.9766 33C56.9766 46.2387 46.2387 56.9766 33 56.9766Z",
    fill: "#dbdbdb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.d4ffc559e62e277433c34df4a07468d0.svg";
export { ForwardRef as ReactComponent };